const paymentDomain = process.env.NEXT_PUBLIC_PAY_LINK;
const baseDomain = process.env.NEXT_PUBLIC_BASE_WUILT_STORE_DOMAIN;

const paymentDomains = [
  "pay.wuiltstore.com",
  "pay.alpha.wuiltstore.com",
  "pay.canary.wuiltstore.com",
];

export const getIsPaymentDomain = (domain: string) => {
  return paymentDomains.includes(domain);
};

export function getPaymentLink(
  storeHandle: string,
  cartId: string,
  authToken?: string | null,
  locale?: string
) {
  if (process.env.NODE_ENV === "development") {
    return `http://${paymentDomain}.localhost:3000/${locale}/store/${storeHandle}/cart/${cartId}${authToken ? `?token=${authToken}` : ""}`;
  }
  return `https://${paymentDomain}/${locale}/store/${storeHandle}/cart/${cartId}${authToken ? `?token=${authToken}` : ""}`;
}

export function getStoreLink({
  storeHandle,
  storeDomain,
  locale,
}: {
  storeHandle: string;
  storeDomain?: string;
  locale?: string;
}) {
  if (storeDomain) {
    if (process.env.NODE_ENV === "development") {
      return `http://${storeDomain}.localhost:3000/${locale}`;
    }
    return `https://${storeDomain}/${locale}`;
  }
  if (process.env.NODE_ENV === "development") {
    return `http://${storeHandle}.${baseDomain}.localhost:3000/${locale}`;
  }
  return `https://${storeHandle}.${baseDomain}/${locale}`;
}
